import { FC } from 'react';
import { DataGridEmptyProps } from './DataGridEmpty.types';
import { AllieText } from '../../../Text';
import { AllieImg } from '../../../Media/Img';
import {
  AllieFunnelOutlineIcon,
  AlliePresentationChartIcon,
} from '../../../../styling/icons/Icons';

const DEFAULT_EMPTY_DATA = 'assets/empty-data.svg';

export const DataGridEmpty: FC<DataGridEmptyProps> = ({
  principalText,
  secondaryText,
  imageSrc = DEFAULT_EMPTY_DATA,
  action,
  icon: Icon,
  isFiltered = false,
  style,
  iconBackground = 'neutral-10',
  maxWidthText = '356px',
}) => {
  return (
    <div
      style={{
        display: 'flex',
        backgroundColor: 'white',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '100%',
        padding: 50,
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {/* {imageSrc && (
        <div style={{ marginTop: 8, margin: 4 }}>
          <AllieImg src={imageSrc} />
        </div>
      )} */}
      <div
        style={{
          backgroundColor: `var(--allie-color-${iconBackground})`,
          width: 85,
          height: 85,
          borderRadius: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 24,
        }}>
        {Icon && <Icon style={{ height: 39, width: 39 }} />}
        {!Icon && isFiltered && <AllieFunnelOutlineIcon style={{ height: 39, width: 39 }} />}
        {!Icon && !isFiltered && <AlliePresentationChartIcon style={{ height: 39, width: 39 }} />}
      </div>
      <div style={{ maxWidth: maxWidthText, textAlign: 'center' }}>
        <div style={{ marginBottom: 16 }}>
          <AllieText
            style={{ textWrap: 'wrap' }}
            type="h4"
            weight={700}
            color="neutral-90"
          >
            {principalText}
          </AllieText>
        </div>
        {secondaryText && (
          <div style={{ marginBottom: 16 }}>
            <AllieText
              type="field1"
              weight={600}
              color="neutral-70"
            >
              {secondaryText}
            </AllieText>
          </div>
        )}
        {action}
      </div>
    </div>
  );
};
